/**
 * Removes TTS "active node" class from any nodes that have it.
 * @param {Document} frameDocument
 */
const removeTTSClass = (frameDocument) => {
  frameDocument?.querySelectorAll('.is-tts-active')?.forEach((element) => {
    element.classList.remove('is-tts-active');
  });
};

export default removeTTSClass;
